export const mbMpup = {
  mpupContact: {
    heading: 'Questions? Pass changes or product requests?',
    getInTouch: 'Get in touch!',
    happyToHelp: 'We are happy to help!'
  },
  mpupHeader: {
    welcome: 'Welcome',
    whatAreYourNeeds: 'What can we do for you today?'
  },
  mpupNavigation: {
    inventory: 'Inventory',
    transactions: 'Transactions',
    user: 'User'
  },
  mpupInventory: {
    inventoryHeading: 'Inventory of ',
    lotNo: 'Lot no.',
    expirationDate: 'Expiration date',
    amount: 'Amount',
    placeholder: 'Search for products',
    of: 'of',
    tray: 'Tray',
    downloadDataSheet: 'Download data sheet',
    visitProductDetails: 'Visit product detail page',
    noResultsFound: 'No results were found.',
    loadingMessage: 'Processing large dataset. Please be patient.',
    sortedByCatalog: 'Sorted by catalog no.'
  },
  mpupTransactions: {
    placeholder: 'Search for product, lot no.or pass infos...',
    transactionsHeading: 'See all transactions of your ',
    transactionTypeFilterName: 'Transaction type',
    passFilterName: 'Pass',
    transactions: 'transactions'
  },
  mpupFilter: {
    none: 'None'
  }
}
